/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Apps/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CustomResource from './CustomResource/index'
import Orders from './Orders/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Apps({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Apps"
  
}) {
let appsShowValueData = fromData.useDataValue({ viewPath,
context: 'apps',
path: 'show',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Apps.Vertical"
  data-view-path={viewPath}
 style={{'--d-1-91hL': appsShowValueData ? "flex" : "none"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 weight="semibold"
 size="normal"
 text="Apps"
/>
<div
  data-testid="Apps.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-2-91hL': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-3-91hL': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<CustomResource
  viewPath={`${viewPath}/CustomResource`}
/>
<Orders
  viewPath={`${viewPath}/Orders`}
/>
</div>
</div>
{children}
</React.Fragment>)
}